import { Dialog } from "@material-ui/core"

const CustomDialog = ({ open, onClose, children, ...rest }) => {

  return (
    <Dialog
      fullWidth={true}
      maxWidth='md'
      scroll='paper'
      open={open}
      onClose={onClose}
      {...rest}
    >
      {children}
    </Dialog>
  )
}

export default CustomDialog;